import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class FoodBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { foodTopic, foodTitle, foodList0, foodList1 },
        } = this.props;

        return (
            <div id="foodNewsList" className={styles.food_box}>
                <Chip id="50073" type="struct" title="美食栏标题" groupName="美食栏" content={foodTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75082"
                    type="recommend"
                    title="美食栏头条"
                    groupName="美食栏"
                    content={foodTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75083"
                    type="recommend"
                    title="美食栏新闻列表1"
                    groupName="美食栏"
                    content={foodList0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList />
                </Chip>
                <Chip
                    id="75084"
                    type="recommend"
                    title="财经梧桐汇新闻列表"
                    groupName="美食栏"
                    content={foodList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(FoodBox);
